export const ExposureDashboardDefaultFilter = {
  'finding.source_names': [],
  'finding.state': [],
  'ticket.assignee_id': [],
  'ticket.current_status.name': [],
  'ticket.state': [],
  'asset.owner_id': [],
};

export const MAX_WIDTH = '1418px';

export const OTHERS_SOURCE_NAME = 'Others';
